// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!./Roles.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ! FIX ICONS FILTER VISIBILITY */
.p-column-filter-menu-button g {
  clip-path: none;
}

html .p-card .p-card-content {
  padding: 0;
}

html {
  font-size: 14px;
}

body {
  font-family: var(--font-family);
  font-weight: normal;
  background: var(--surface-ground);
  color: var(--text-color);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html,
body,
#root {
  height: 100%;
  padding: 0;
}

html, body {
  overflow-y: hidden;
  overflow-x: hidden;
}

.wrapper:not(.wrapper.wrapper--main) {
  padding: 1rem 1rem 0 1rem;
}

.wrapper--main {
  padding: 0 1rem;
}

.p-datatable .p-component-overlay {
  background-color: unset;
}

.p-datatable-table > .p-datatable-tbody > tr > td {
  white-space: normal !important;
  word-wrap: break-word;
  word-break: break-word;
}
.taskType-table .p-datatable-thead > tr > th {
  white-space: normal;
  overflow-wrap: anywhere;
}

.taskType-table .p-column-filter-row {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  min-width: 0;
}

.taskType-table .p-column-filter-row .p-column-filter-element {
  flex: 1 1 auto;
  min-width: 0;
}

.taskType-table .p-column-filter-row .p-column-filter-element > div,
.taskType-table .p-column-filter-row .p-inputtext {
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
}

.taskType-table .p-column-filter-row .p-column-filter-menu-button {
  flex: 0 0 auto;
}

.card {
  background: var(--surface-card);
  padding: 2rem;
  border-radius: 10px;
  margin-bottom: 1rem;
}

.card-errors {
  display: flex;
  align-items: center;
  min-height: 16px;
  font-size: 12px;
}

.dialog-tabless-card .default-card__buttons {
  margin-top: 50px;
  margin-bottom: 7px;
}

.button-with-tab {
  margin-top: 14px;
  padding: 0 17.5px;
}

.custom-employee-card-buttons {
  margin-top: 32.5px;
  padding-left: 17.5px;
}

.card-row--bottom-margin {
  margin-bottom: 16px;
}

.dialog-card__row:not(.tag-component) {
  margin-top: 16px;
}

.tag-component:not([class*='card'] .tag-component) {
  margin-top: 9px;
}

.p-card {
  margin-top: 16px;
}

.default-card__buttons:not(.dialog-tabless-card .default-card__buttons) {
  padding: 0 17.5px;
  bottom: 35px;
  position: absolute;
  top: auto;
  margin-bottom: 0;
}

.dialog-tabless-card--fixed-footer .default-card__buttons {
  bottom: 35px;
  position: absolute;
  top: auto;
  margin-bottom: 0;
}

.dialog-tabless-card--fixed-footer .default-card__buttons--mobile{
  margin-top: 20px;
  bottom: 0;
  position: relative;
}

.dialog-tabless-card {
  padding: 0 17.5px;
}

.app {
  text-align: center;
}

.app-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .app-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.app-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.app-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.p-datatable-thead:not(.p-datatable-row-expansion .p-datatable-thead) {
  z-index: 2;
}
/* Ограничение ширины Dropdown и его выпадающего списка */

.p-dropdown-item {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.col {
  max-width: 100%;
  overflow: hidden;
}

.assignmentsAbsenceCard-dropdown--panel .p-dropdown-item {
  word-break: break-all;
  white-space: normal;
}

.p-dropdown-panel {
  width: 100px;
}
`, "",{"version":3,"sources":["webpack://./src/ui/css/App.css"],"names":[],"mappings":"AAEA,kCAAkC;AAClC;EACE,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,iCAAiC;EACjC,wBAAwB;EACxB,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;;;EAGE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;EACrB,sBAAsB;AACxB;AACA;EACE,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,cAAc;EACd,YAAY;AACd;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,UAAU;AACZ;AACA,yDAAyD;;AAEzD;EACE,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd","sourcesContent":["@import url(Roles.css);\n\n/* ! FIX ICONS FILTER VISIBILITY */\n.p-column-filter-menu-button g {\n  clip-path: none;\n}\n\nhtml .p-card .p-card-content {\n  padding: 0;\n}\n\nhtml {\n  font-size: 14px;\n}\n\nbody {\n  font-family: var(--font-family);\n  font-weight: normal;\n  background: var(--surface-ground);\n  color: var(--text-color);\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml,\nbody,\n#root {\n  height: 100%;\n  padding: 0;\n}\n\nhtml, body {\n  overflow-y: hidden;\n  overflow-x: hidden;\n}\n\n.wrapper:not(.wrapper.wrapper--main) {\n  padding: 1rem 1rem 0 1rem;\n}\n\n.wrapper--main {\n  padding: 0 1rem;\n}\n\n.p-datatable .p-component-overlay {\n  background-color: unset;\n}\n\n.p-datatable-table > .p-datatable-tbody > tr > td {\n  white-space: normal !important;\n  word-wrap: break-word;\n  word-break: break-word;\n}\n.taskType-table .p-datatable-thead > tr > th {\n  white-space: normal;\n  overflow-wrap: anywhere;\n}\n\n.taskType-table .p-column-filter-row {\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n  min-width: 0;\n}\n\n.taskType-table .p-column-filter-row .p-column-filter-element {\n  flex: 1 1 auto;\n  min-width: 0;\n}\n\n.taskType-table .p-column-filter-row .p-column-filter-element > div,\n.taskType-table .p-column-filter-row .p-inputtext {\n  width: 100%;\n  min-width: 0;\n  box-sizing: border-box;\n}\n\n.taskType-table .p-column-filter-row .p-column-filter-menu-button {\n  flex: 0 0 auto;\n}\n\n.card {\n  background: var(--surface-card);\n  padding: 2rem;\n  border-radius: 10px;\n  margin-bottom: 1rem;\n}\n\n.card-errors {\n  display: flex;\n  align-items: center;\n  min-height: 16px;\n  font-size: 12px;\n}\n\n.dialog-tabless-card .default-card__buttons {\n  margin-top: 50px;\n  margin-bottom: 7px;\n}\n\n.button-with-tab {\n  margin-top: 14px;\n  padding: 0 17.5px;\n}\n\n.custom-employee-card-buttons {\n  margin-top: 32.5px;\n  padding-left: 17.5px;\n}\n\n.card-row--bottom-margin {\n  margin-bottom: 16px;\n}\n\n.dialog-card__row:not(.tag-component) {\n  margin-top: 16px;\n}\n\n.tag-component:not([class*='card'] .tag-component) {\n  margin-top: 9px;\n}\n\n.p-card {\n  margin-top: 16px;\n}\n\n.default-card__buttons:not(.dialog-tabless-card .default-card__buttons) {\n  padding: 0 17.5px;\n  bottom: 35px;\n  position: absolute;\n  top: auto;\n  margin-bottom: 0;\n}\n\n.dialog-tabless-card--fixed-footer .default-card__buttons {\n  bottom: 35px;\n  position: absolute;\n  top: auto;\n  margin-bottom: 0;\n}\n\n.dialog-tabless-card--fixed-footer .default-card__buttons--mobile{\n  margin-top: 20px;\n  bottom: 0;\n  position: relative;\n}\n\n.dialog-tabless-card {\n  padding: 0 17.5px;\n}\n\n.app {\n  text-align: center;\n}\n\n.app-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .app-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.app-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.app-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.p-datatable-thead:not(.p-datatable-row-expansion .p-datatable-thead) {\n  z-index: 2;\n}\n/* Ограничение ширины Dropdown и его выпадающего списка */\n\n.p-dropdown-item {\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.col {\n  max-width: 100%;\n  overflow: hidden;\n}\n\n.assignmentsAbsenceCard-dropdown--panel .p-dropdown-item {\n  word-break: break-all;\n  white-space: normal;\n}\n\n.p-dropdown-panel {\n  width: 100px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
